(function() {

    'use strict';

    /**
     * @module Plugins
     *
     * Takes care of loading and displaying subtitles for SAPO Videos videos.
     *
     * @namespace sv_subtitles
     */

    var _    = SAPO.Project.Video._,
        cors = SAPO.Utility.cors,
        Css  = SAPO.Dom.Css,
        Feat = SAPO.Project.Video.Features;


    if (Feat.isIPhoneOrIPod) { // skip suggestions on iphone-like devices
        return;
    }


    var genId = function() {
        return 'sub_' + ( ~~(Math.random() * Math.pow(32, 6)) ).toString(32);
    };



    var plugin = function(vc, ui, pub, pubD) {
        this._vc = vc;
        this._ui = ui;
        this._pub = pub;
        this._pubD = pubD;

        this._bags       = {};
        this._currentBag = undefined;
        this._md         = {};
        this._fontSize   = 10;

        this._vc.subscribe('button_activated load metadata_changed resize', undefined, this);

        this._btnEl = this._ui.addButton('sv-subtitles', 'right');
        this._ui.hideButton('sv-subtitles');
    };

    plugin.prototype = {

        _name: plugin._name = 'sv_subtitles',

        on_button_activated: function(mt, id) {
            if (id !== 'sv-subtitles' || !this._currentBag) { return; }

            Css.setClassName(this._btnEl, 'active', this._isActive);

            Css.toggleClassName(this._ui._els.player, 'subtitles-on');
        },

        on_metadata_changed: function(mt, md) {
            // console.log('metadata_changed');
            this._md = md;
            // console.log('MD:', this._md);
        },

        on_load: function(mt, o) {
            // console.log('load');

            this._removeSubs();

            var md = this._md;

            this._requestURL = o.requestURL;
            //console.log(this._requestURL);

            if (md.hasSubtitles) {
                this._ui.showButton('sv-subtitles');

                if (this._btnEl) {
                    this._btnEl.title = _('subtitlesTitle');
                }

                this._currentBag = this._bags[ this._requestURL ];
                // console.log(this._requestURL, this._currentBag);
                if (!this._currentBag) {
                    this._getDocument();
                }
                else {
                    this._sendSubsToOverlay();
                }
            }
            else {
                this._ui.hideButton('sv-subtitles');
            }

            //Css.removeClassName(this._ui._els.player, 'subtitles-on');
        },

        on_resize: function(mt, dimsO) {
            var dims = dimsO.container;
            var f  = Math.round( Math.min(dims[0], dims[1]) * 0.05 ),
                f2 = Math.round( f / 2),
                f4 = Math.round( f / 4);
            this._fontSize = f;

            var styleEl = s$('subtitles-css');
            var css = [
                '.sub {',
                '    bottom: ' + f2 + 'px;',
                '    font-size: ' + f + 'px;',
                '    padding: 0 ' + f4 + 'px;',
                '}'
            ].join('\n');

            if (styleEl.styleSheet) { // IE
                styleEl.styleSheet.cssText = css;
            }
            else {
                styleEl.innerHTML = css;
            }
        },



        _getDocument: function() {
            // console.log('getting subs document');
            var subUri = [this._md.queryDomain, this._md.hash, 'subsjson'].join('/');

            cors(
                subUri,
                this._parseDocument.bindObj(this),
                function() { /*console.log('ERROR GETTING SUBTITLES!');*/ },
                5,
                false
            );
        },

        _parseDocument: function(tmp, data) {
            if (typeof data === 'string') {
                try {
                   data = JSON.parse(data);
                }
                catch (ex) {
                    return;
                }
            }

            var d, sub, text, subs = [];
            for (var i = 0, f = data.length; i < f; ++i) {
                d = data[i];

                text = d.text;

                if (!text) {
                    continue;
                }
                text = text.split('\n');

                sub = {
                    kind:   'subtitle',
                    id:     genId(),
                    start:  d.start,
                    end:    d.end,
                    lines:  text
                };

                subs.push(sub);
            }

            this._currentBag = subs;
            this._bags[ this._requestURL ] = subs;

            //console.log('SUBS:', subs);
            this._sendSubsToOverlay();
        },

        _sendSubsToOverlay: function() {
            var subs = this._currentBag;
            //console.log('sending ' + subs.length + ' subs to overlay with requestURL ' + this._requestURL);
            if (!subs) { return; }

            for (var i = 0, f = subs.length; i < f; ++i) {
                this._pub('add_timeline', subs[i], this._requestURL);
            }
            //console.log('...');
        },

        _removeSubs: function() {
            // console.log('remove subs!');
            this._pub('remove_timeline_prefix', 'sub_');
            this._pub('remove_overlay_prefix', 'sub_');
        }

    };

    SAPO.Project.Video.Controllers._plugins.push(plugin);

})(undefined);
